import bronzeBadge from '~images/Bronze Badge.png';
import silverBadge from '~images/Silver Badge.png';
import goldBadge from '~images/Gold Badge.png';

import {
  Box,
  Container,
  Flex,
  Modal,
  ModalProps,
  Spacer,
  StyledSup,
} from 'voom-gatsby';
import { Paragraph } from 'voom-gatsby';
import { PINK } from 'voom-gatsby/src/themes/bunionplasty/colors';

const Info = () => {
  return (
    <Box
      sx={{
        bg: 'beige',
        overflowY: 'scroll',
      }}
    >
      <Container
        sx={{
          maxWidth: [500, null, null, null, 800],
          pt: [8, null, 9],
          pb: [7, null, 9],
        }}
      >
        <Flex sx={{
          flexDirection: 'column',
          alignItems: 'center'
        }}>
          <Paragraph variant="h4" sx={{ textAlign: 'center', color: PINK }}>Bunionplasty<StyledSup>®</StyledSup> Procedure Experience Badges</Paragraph>
          <Spacer space={4} direction={'vertical'}></Spacer>
          <div>
            <Flex sx={{
              flexDirection: 'row',
              justifyContent: 'space-evenly',
            }}>
              <Flex sx={{
                flexDirection: 'column',
                alignItems: 'center'
              }}>
                <img src={goldBadge} style={{ width: '40px' }}></img>
                <Spacer space={2}></Spacer>
                <p>Gold</p>
                <p>Experience</p>
              </Flex>
              <Flex sx={{
                flexDirection: 'column',
                alignItems: 'center'
              }}>
                <img src={silverBadge} style={{ width: '40px' }}></img>
                <Spacer space={2}></Spacer>
                <p>Silver</p>
                <p>Experience</p>
              </Flex>
              <Flex sx={{
                flexDirection: 'column',
                alignItems: 'center'
              }}>
                <img src={bronzeBadge} style={{ width: '40px' }}></img>
                <Spacer space={2}></Spacer>
                <p>Bronze</p>
                <p>Experience</p>
              </Flex>
            </Flex>
            <Spacer space={4}></Spacer>
            <Paragraph variant="disclaimer" css="text-align: center">
              The experience badges reflect the number of Bunionplasty® 360° Bunion Repair™ procedures the surgeon has performed.
              Surgeons may have additional experience with other MIS bunion techniques.
              The badges are not intended to reflect the quality or skill level of the provider nor be viewed as an endorsement or recommendation of any provider.
            </Paragraph>
          </div>
        </Flex>

      </Container>
    </Box>
  );
};

export const DoctorSearchBadgeInfoModal = ({
  isOpen,
  open,
  close,
}: Omit<ModalProps, 'children'>) => {
  return (
    <>
      <Modal
        close={close}
        open={open}
        isOpen={isOpen}
        css={{
          // use fallback for mobile height
          '&[data-reach-dialog-content]': {
            height: ['100vh', '100dvh'],
            maxHeight: ['100vh', '100dvh'],
          },
        }}
        sx={{
          '&[data-reach-dialog-content]': {
            maxWidth: 800,
            maxHeight: [null, '60vh !important'],
            width: ['100vw', '95vw', '80vw'],
            borderRadius: [0, 'rounded'],
          },
        }}>
        <Info></Info>
      </Modal>
    </>
  );
};

